"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getLifeJournalEntries_1 = __importDefault(require("./graphql/getLifeJournalEntries"));
const getMindJournalEntries_1 = __importDefault(require("./graphql/getMindJournalEntries"));
class Journal {
    constructor(client) {
        this.client = client;
    }
    async getLifeJournalDailyEntries(customerId, date) {
        return this.client.fetch("getLifeJournalDailyEntries", getLifeJournalEntries_1.default, {
            from: date,
            to: date,
            userId: Number(customerId),
        });
    }
    async getMindJournalDailyEntries(customerId, date) {
        return this.client.fetch("getMindJournalDailyEntries", getMindJournalEntries_1.default, {
            from: date,
            to: date,
            userId: Number(customerId),
        });
    }
    async getLifeWeeklyEntries(customerId, startDate, endDate) {
        return this.client.fetch("getLifeJournalDailyEntries", getLifeJournalEntries_1.default, {
            from: startDate,
            to: endDate,
            userId: Number(customerId),
        });
    }
    async getMindWeeklyEntries(customerId, startDate, endDate) {
        return this.client.fetch("getMindJournalDailyEntries", getMindJournalEntries_1.default, {
            from: startDate,
            to: endDate,
            userId: Number(customerId),
        });
    }
}
exports.default = Journal;
//# sourceMappingURL=Journal.js.map